<form class="password-parametrization__form" [formGroup]="resetPassword" (ngSubmit)="onSubmit()">
  <div class="mb-4" *ngIf="isOldPasswordInputVisible">
    <label class="mr-inter-text-med d-block" for="old-password">Contraseña actual</label>
    <mat-form-field class="d-block" appearance="outline">
      <input id="old-password" [type]="showOldPassword ? 'text' : 'password'" formControlName="oldPassword" matInput>
      <button type="button" mat-icon-button matSuffix (click)="showOldPassword = !showOldPassword">
        <mat-icon>{{showOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="mb-4">
    <label class="mr-inter-text-med d-block" for="url-validity">
      <span *ngIf="isOldPasswordInputVisible">Nueva contraseña</span>
      <span *ngIf="!isOldPasswordInputVisible">Contraseña</span>
    </label>
    <mat-form-field class="d-block" appearance="outline">
      <input id="url-validity" [type]="showNewPassword ? 'text' : 'password'" formControlName="password" matInput>
      <button type="button" mat-icon-button matSuffix (click)="showNewPassword = !showNewPassword">
        <mat-icon>{{showNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="mb-4">
    <label class="mr-inter-text-med d-block" for="confirm-password">Confirme la contraseña</label>
    <mat-form-field class="d-block" appearance="outline">
      <input id="confirm-password" [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" matInput>
      <button type="button" mat-icon-button matSuffix (click)="showConfirmPassword = !showConfirmPassword">
        <mat-icon>{{showConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-hint align="start" *ngIf="confirPasswordIsDirtyAndTouched && confirmPassword.hasError('mismatch')">
        <strong class="error">La contraseña no coincide</strong>
      </mat-hint>
    </mat-form-field>
  </div>
  <div class="mb-4" [class]="{'btn-container': closable}">
    <button type="button" class="btn btn-cancel  d-block w-full" mat-button *ngIf="closable" (click)="resetModal()">
      {{cancelButtonText()}}
    </button>
    <button type="submit" class="mr-button-general d-block w-full" mat-button [disabled]="invalidForm">
      Guardar
    </button>
  </div>
  <motor-calculo-password-instructions [passwordControl]="password"
    *ngIf="showInstructions"></motor-calculo-password-instructions>
</form>
